"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DowngradeWorksheetFomattingNotification175 = exports.DowngradeWorksheetFomatting175 = void 0;
exports.DowngradeWorksheetNames = DowngradeWorksheetNames;
exports.DowngradeFlipboardZoneID = DowngradeFlipboardZoneID;
exports.DowngradeExtensionEnvironmentContext = DowngradeExtensionEnvironmentContext;
exports.DowngradePeriodType = DowngradePeriodType;
const JsApiInternalContract_1 = require("../JsApiInternalContract");
const Notifications_1 = require("../contract/Notifications");
// This is where we will start to define some of these translations.
// When modifying existing models, add the requisite conversion functions here, then use them
// in the VersionConverterFactory implementation. Import old versions as you would any other module
// 0 <-> Translations
// Uncomment this line to import from the V0 definition of the API
// import * as V0 from '@tableau/api-internal-contract-js-v0';
// 1 <-> 2 Translations
// Uncomment this line to import from the V1 definition of the API
// import * as V1 from '@tableau/api-internal-contract-js-v1';
function DowngradeWorksheetNames(executeResponse) {
    // Fix the dashboard friendly name issue. The structures are compatible,
    // so we still return the original reply, but we copy the SheetInfo.name
    // into the DashboardZone.name, where v1 wants to find it.
    const bootstrapInfo = executeResponse.result;
    if (bootstrapInfo.extensionDashboardInfo !== undefined) {
        bootstrapInfo.extensionDashboardInfo.zones.forEach((zone) => {
            if (zone.sheetInfo) {
                zone.name = zone.sheetInfo.name;
            }
        });
    }
    return executeResponse;
}
function DowngradeFlipboardZoneID(notification) {
    // Fix the FlipboardZoneId issue. Older external versions still check for flipboardZoneIDs.
    // When running against a newer server, if flipboardZoneId is absent, set it to default(0).
    if (notification.notificationId === Notifications_1.NotificationId.SelectedMarksChanged) {
        const visualModel = notification.data;
        if (visualModel.flipboardZoneID === undefined) {
            visualModel.flipboardZoneID = 0;
        }
    }
    return notification;
}
// Filter out formatting sheets that are specified in the classNames list
function DowngradeWorksheetFormatting(executeResponse, classNames) {
    var _a;
    const bootstrapInfo = executeResponse.result;
    if ((_a = bootstrapInfo === null || bootstrapInfo === void 0 ? void 0 : bootstrapInfo.extensionWorksheetInfo) === null || _a === void 0 ? void 0 : _a.formatting)
        bootstrapInfo.extensionWorksheetInfo.formatting.formattingSheets =
            bootstrapInfo.extensionWorksheetInfo.formatting.formattingSheets.filter((x) => !classNames.includes(x.classNameKey));
    return executeResponse;
}
// Filter out formatting sheets that are specified in the classNames list
// Filter out formatting sheets that are specified in the classNames list
function DowngradeWorksheetFormattingNotification(notification, classNames) {
    if (notification.notificationId === Notifications_1.NotificationId.WorksheetFormattingChanged) {
        const formatting = notification.data;
        notification.data = formatting.formattingSheets.filter((x) => !classNames.includes(x.classNameKey));
    }
    return notification;
}
// We added new enum values for ClassNameKeys enum in 176. Need to filter them out if the client version is <176
const ClassNameKeysToFilter175 = ["tableau-row-dividers" /* ClassNameKey.RowDividers */, "tableau-column-dividers" /* ClassNameKey.ColumnDividers */, "tableau-pane" /* ClassNameKey.Pane */];
const DowngradeWorksheetFomatting175 = (response) => DowngradeWorksheetFormatting(response, ClassNameKeysToFilter175);
exports.DowngradeWorksheetFomatting175 = DowngradeWorksheetFomatting175;
const DowngradeWorksheetFomattingNotification175 = (notification) => DowngradeWorksheetFormattingNotification(notification, ClassNameKeysToFilter175);
exports.DowngradeWorksheetFomattingNotification175 = DowngradeWorksheetFomattingNotification175;
function DowngradeExtensionEnvironmentContext(executeResponse) {
    // Fix the extension environment context issue. Replaces new enum values that go unrecognized
    // by older extensions with their respective older enum values.
    const bootstrapInfo = executeResponse.result;
    if (bootstrapInfo.extensionEnvironment !== undefined) {
        const context = bootstrapInfo.extensionEnvironment.extensionContext;
        if (context === JsApiInternalContract_1.ExtensionContext.PublicWeb || context === JsApiInternalContract_1.ExtensionContext.Cloud) {
            bootstrapInfo.extensionEnvironment.extensionContext = JsApiInternalContract_1.ExtensionContext.Server;
        }
        else if (context === JsApiInternalContract_1.ExtensionContext.PublicDesktop) {
            bootstrapInfo.extensionEnvironment.extensionContext = JsApiInternalContract_1.ExtensionContext.Desktop;
        }
    }
    return executeResponse;
}
function HandleDowngradePeriodTypeForParameter(parameter) {
    if (parameter.allowableValuesType === JsApiInternalContract_1.DomainRestrictionType.Range) {
        if (parameter.dateStepPeriod === JsApiInternalContract_1.DateStepPeriod.IsoYears) {
            parameter.dateStepPeriod = JsApiInternalContract_1.DateStepPeriod.Years;
        }
        else if (parameter.dateStepPeriod === JsApiInternalContract_1.DateStepPeriod.IsoQuarters) {
            parameter.dateStepPeriod = JsApiInternalContract_1.DateStepPeriod.Quarters;
        }
        else if (parameter.dateStepPeriod === JsApiInternalContract_1.DateStepPeriod.IsoWeeks) {
            parameter.dateStepPeriod = JsApiInternalContract_1.DateStepPeriod.Weeks;
        }
    }
}
function DowngradePeriodType(executeResponse) {
    if (Array.isArray(executeResponse.result)) {
        const parameters = executeResponse.result;
        for (const parameter of parameters) {
            HandleDowngradePeriodTypeForParameter(parameter);
        }
    }
    else {
        const parameter = executeResponse.result;
        HandleDowngradePeriodTypeForParameter(parameter);
    }
    return executeResponse;
}
//# sourceMappingURL=VersionTranslations.js.map